import { section } from "shared/data";

export const FilterOptions = [
  {
    filters: [
      section.video.scmpFilms,
      section.video.scmpExplains,
      section.video.deepDive,
      section.video.tellMe,
      section.video.talkingPost,
      section.video["852"],
      section.video.eatDrinkAsia,
      section.video.justSaying,
    ],
    header: "Series:",
  },
  {
    filters: [
      section.video.hongKong,
      section.video.china,
      section.video.world,
      section.video.business,
      section.video.technology,
      section.video.lifestyle,
      section.video.sport,
      section.video.opinion,
    ],
    header: "Sections:",
  },
];
